// Module
var code = `<nav>
  <a
    class="home selected"
    href=""
    data-page-id="home"
    data-event-prevent-default="true"
    >Home</a
  >
  <a class="blog" href="" data-page-id="blog" data-event-prevent-default="true"
    >Blog</a
  >
  <a
    class="profile"
    href=""
    data-page-id="profile"
    data-event-prevent-default="true"
    >Profile</a
  >
  <a
    class="about"
    href=""
    data-page-id="about"
    data-event-prevent-default="true"
    >About</a
  >
</nav>
`;
// Exports
module.exports = code;